import React                from 'react'
import axios                from 'axios'
import config               from './config'
import moment               from 'moment-timezone'
import DeveloperUsage       from './DeveloperUsage'
import DeveloperUsageTable  from './DeveloperUsageTable'
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';

export default class Layer extends React.Component {
  constructor(props) {
    super(props)
    this.handleDayClick = this.handleDayClick.bind(this)
    this.state = {
      developerIds: [],
      developerUsageFound: [],
      developerUsageFoundInformation: {},
      developersUsageHourly: {},
      developersUsageDaily: {},
      developersUsageByStatusCode: [],
      now: null,
      dateBegin: moment().utc().subtract(7, "days").add(1, "hours"),
      dateEnd: moment().utc().add(1, "hours"),
      dayPickerErrors: "",
      meKey: "",
      developersKey: []
    }
    axios.defaults.withCredentials = true
  }

  componentWillMount() {
    this.setState({
      dateEnd: moment().utc().add(1, "hours"),
      dateBegin: moment().utc().subtract(7, "days").add(1, "hours")
    })
    var localDeveloperIds = []
    var devFound = new Set()
    var localDeveloperUsageFoundInformation = {}

    var meKey = undefined
    this.getMe().then(me => {
      meKey = me.data.data.developer.key
      this.setState({
        meKey: meKey
      })
    }).then(() => {
      this.getDeveloperSubscriptions().then(resp => {
        // Filter out the front end developer
        var devs = resp.data.developer.filter(d => {
          return !d.developerSubscription.some(ds => {
            // Try and catch to avoid null pointer exception
            try {
              var limitObj = ds.meta.metadata.requestLimit["POST/detect"]
              return limitObj.time === 1 && limitObj.limit === 0
            } catch(err) {
              return false
            }
          }) > 0
        })//.slice(1,10) //only for testing
        
        devs.forEach(dev => {
          var devId = dev.id.split("dev_")[1]
          var detSet = dev.developerSubscription.filter(devSub => devSub.developerPlanId === 'devpla_11')[0].detectionSetting
          var detSetId = detSet.id.split("detset_")[1]
          var detSetService = detSet.service
          var deployment = detSet.deployment[0]
          var localDevUsageFoundInfo = {
            id: detSetId,
            service: detSetService,
            developer: {
              id: dev.id,
              company: {
                id: dev.company.id,
                name: dev.company.name
              },
              isVideo: deployment.video,
              isSync: deployment.synchronous,
              isOnDemand: deployment.onDemand,
              layer: deployment.layer
            }
          }
          if(!devFound.has(devId)) {
            localDeveloperIds.push(devId)
            localDeveloperUsageFoundInformation[devId] = localDevUsageFoundInfo
            devFound.add(devId)
          }
        })
      }).then(()=> {
        this.setState({
          developerUsageFoundInformation: localDeveloperUsageFoundInformation,
          developerIds: localDeveloperIds
        })
  
        this.getDevelopers(localDeveloperIds).then(resp => {
          var devs = resp.data.developer
          var developersKey = []
          var promises = devs.map(dev => {
            var did = dev.id.split("_")[1]
            developersKey.push({
              key:dev.key,
              id: did
            })
            return this.getDeveloperUsage(did, dev.key, true, this.state.dateBegin.clone(), this.state.dateEnd.clone())
          })
          this.setState({
            developersKey: developersKey
          })
          Promise.all(promises)
        })
      })
    })
  }

  numberWithCommas(x) {
    x = x.toString();
    var pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x))
      x = x.replace(pattern, "$1,$2");
    return x;
  }

  getDeveloperSubscriptions() {
    return axios.get(config.GRAPH.ENDPOINT + 'deployment.equal(status,1)/detectionSetting/developerSubscription.equal(developerPlanId,11).equal(status,1)/developer' + config.GRAPH.VERSION + '&fields=company,developerSubscription(id,developerPlanId,meta,detectionSetting(id,service,deployment(video,onDemand,synchronous,layer)))').catch(_ => console.log())
  }

  getDetectionSettings() {
    return axios.get(config.GRAPH.ENDPOINT + 'detectionSetting' + config.GRAPH.VERSION + '&fields=id,developer(id),service').catch(_ => console.log())
  }

  getDevelopers(dids) {
    return axios.get(config.GRAPH.ENDPOINT + 'developer.in(id,' + dids + ')' + config.GRAPH.VERSION + '&fields=key,id').catch(_ => console.log())
  }

  getDeveloperUsage(did, devKey, updateDevFound, dateBegin, dateEnd) {
    var supportedStatusCode = [200, 202, 400, 401, 403, 404, 415, 429, 500, 501, 504]
    var localDeveloperUsageDaily = {}
    var localDeveloperUsageHourly = []
    var localDeveloperUsageByStatusCode = {}
    return (
      this.getLimits(devKey, this.state.meKey, dateBegin.clone(), dateEnd.clone()).then(r => {
        var usage = r.data.data['POST/detect'].usage
        if(!usage) {
          usage = []
        }
        usage.forEach(u => {
          var statusCode = u.statusCode
          
          // Set localDevelopersUsageDayly
          var day = u.timeBegin.split(" ")[0]
          if(localDeveloperUsageDaily[day]){
            localDeveloperUsageDaily[day] += u.count
          } else {
            localDeveloperUsageDaily[day] = u.count
          }

          // Set localDeveloperUsageHourly
          if(statusCode === 200 || statusCode === 202) {
            localDeveloperUsageHourly.push({
              time: u.timeBegin,
              requests: u.count
            })
          }

          // Set localDeveloperUsageByStatusCode
          if(supportedStatusCode.includes(statusCode)) {
            if(!localDeveloperUsageByStatusCode[statusCode]) {
              localDeveloperUsageByStatusCode[statusCode] = []
            }
            localDeveloperUsageByStatusCode[statusCode].push({
              nRequests: u.count,
              statusCode: statusCode,
              time: u.timeBegin
            })
          }

          // Store duration if it is a video
          if(this.state.developerUsageFoundInformation[did].developer.isVideo && u.duration) {
            if(!localDeveloperUsageByStatusCode["duration"]) {
              localDeveloperUsageByStatusCode["duration"] = []
            }
            localDeveloperUsageByStatusCode["duration"].push({
              nRequests: u.duration.time,
              time: u.timeBegin
            })
          }
        })
      }).then(() => {
        return(this.getNumberOfRequests(did, this.state.dateBegin.clone(), this.state.dateEnd.clone()).then(r => {
          r.data.data.forEach(d => {
            if(!localDeveloperUsageByStatusCode["all"]) {
              localDeveloperUsageByStatusCode["all"] = []
            }
            localDeveloperUsageByStatusCode["all"].push({
              nRequests: d.requests,
              time: d.time
            })
          })
        }).then(() => {
          return(this.setState(state => {
            var developerUsageHourly = state.developersUsageHourly
            developerUsageHourly[did] = localDeveloperUsageHourly
            developerUsageHourly[did]["dateBegin"] = dateBegin.clone()

            var developersUsageDaily = state.developersUsageDaily
            developersUsageDaily[did] = localDeveloperUsageDaily            

            var developersUsageByStatusCode = state.developersUsageByStatusCode
            developersUsageByStatusCode[did] = localDeveloperUsageByStatusCode

            // This value should be updated only on the first load
            if(updateDevFound) {
              var developerUsageFound = state.developerUsageFound
              developerUsageFound.push(did)

              return {
                developersUsageHourly:        developerUsageHourly,
                developersUsageDaily:         developersUsageDaily, 
                developerUsageFound:          developerUsageFound,
                developersUsageByStatusCode:  developersUsageByStatusCode
              }
            } else {
              return {
                developersUsageHourly:        developerUsageHourly,
                developersUsageDaily:         developersUsageDaily,
                developersUsageByStatusCode:  developersUsageByStatusCode
              }
            }
          }))
        }))
      })
    )
  }

  getLimits(key, adminKey, dateBegin, dateEnd) {
    var params = {
      withCredentials: false,
      headers: {
        'X-DEVELOPER-KEY': key,
        'X-ADMIN-KEY': adminKey
      }
    }
    return axios.get(config.API.ENDPOINT + "limits?dateBegin=" + dateBegin.format('YYYY-MM-DD') + "&dateEnd=" + dateEnd.format('YYYY-MM-DD'), params).catch(_ => console.log())
  }

  getMe() {
    return axios.get(config.API.ENDPOINT + 'me').catch(_ => console.log())
  }

  getNumberOfRequests(did, dateBegin, dateEnd) {
    return axios.get(config.API.ENDPOINT + "redis/developer/" + did + "?dateStart=" + dateBegin.format('YYYY-MM-DD-HH') + "&dateEnd=" + dateEnd.format('YYYY-MM-DD-HH')).catch(_ => console.log())
  }

  handleDayClick(day) {
    var selected = moment(day)
    var now = moment().utc()
    if(selected.isAfter(now.clone().subtract(6, "days").add(1, "hours"))){
      this.setState({
        dayPickerErrors: "Please select a start day before " + moment().utc().subtract(7, "days").add(1, "hours").format("DD/MM/YY")
      })
    } else {
      var dateBegin = selected.set({
        hour: now.hours(),
        minutes: now.minutes()
      }).add(1, "hours").add(-1, "days")
      var dateEnd = dateBegin.clone().add(7, "days")
      
      this.setState({
        dayPickerErrors: "",
        dateBegin: dateBegin,
        dateEnd: dateEnd
      })

      // this.resetState()

      var promises = this.state.developersKey.map(dev => {
        return this.getDeveloperUsage(dev.id, dev.key, false, dateBegin, dateEnd)
      })
      Promise.all(promises)
    }
  }

  render() {
    const {developerUsageFound, developersUsageByStatusCode, developerUsageFoundInformation, developersUsageDaily, dateBegin, dateEnd, developersUsageHourly} = this.state
    
    return(
      <div>
        Start date: 
        <DayPickerInput
          onDayChange={this.handleDayClick}
          formatDate={formatDate}
          parseDate={parseDate}
          format="DD/MM/YY"
          placeholder={this.state.dateBegin.format("DD/MM/YY")}
          selectedDay={this.state.dateBegin}
          value={this.state.dateBegin.clone().add(1, "day").format("DD/MM/YY")}
          keepFocus={false}
        />
        {this.state.dayPickerErrors}
        {developerUsageFound.map(did => {
          var props = {}
          props.developerUsageHourly = developersUsageHourly[did]
          props.did = did
          props.dateBegin = dateBegin
          props.dateEnd = dateEnd

          var propsByStatusCode = {}
          propsByStatusCode.developerUsage = developersUsageByStatusCode[did]
          propsByStatusCode.did = did
          propsByStatusCode.totalUsage = developersUsageDaily[did]
          propsByStatusCode.dateBegin = dateBegin
          propsByStatusCode.dateEnd = dateEnd

          var domain = "https://" + window.location.hostname
          var companyId = developerUsageFoundInformation[did].developer.company.id.split("com_")[1]
          var detectionSettingId = developerUsageFoundInformation[did].id

          return (
            <div key={'devUse' + did}>
              <h3><a href={domain + "/backoffice/admin/developers/" + did}>{did}</a>  - <a href={domain + "/backoffice/admin/detectionSettings/" + detectionSettingId}>{detectionSettingId} {developerUsageFoundInformation[did].service}</a></h3>
              <b>Company:</b> <a href={domain + "/backoffice/admin/companys/" + companyId}> {companyId} - {developerUsageFoundInformation[did].developer.company.name}</a><br/>
              <a><b>Client type:</b> {developerUsageFoundInformation[did].developer.isVideo ? "video" : "image"} - {developerUsageFoundInformation[did].developer.isSync ? "sync" : "async"} - {developerUsageFoundInformation[did].developer.isOnDemand ? "onDemand" : "default"} - {developerUsageFoundInformation[did].developer.layer}</a><br/><br/>
              <div key={'devUsageByStatusCode' + did}><DeveloperUsageTable data={propsByStatusCode}/></div>
              <div key={'devUsage' + did}><DeveloperUsage data={props}/></div>
            </div>
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Usage.js